module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGMAAABjCAMAAAC45U6nAAAAPFBMVEVBid3G3PX///9FjN50qOaqyvDg7PpXluGPuuv0+P1GjN7+/v+ixu/5/P5+r+hKj9+yz/FinuNgnOPP4fZ+wd1vAAAAo0lEQVR4Ae3V1WFDMRSDYVWXmfaftdyG82SdkL4FfrNhZmZmZmb20t6gR8hlhByZBzQIsSKgwU9lQIOQqgIa/FYHNPjojYY/WqTV8boeKfAaJCJO/Bh4THGIxZP4IU78GMWFHwGJgfsm/TQ4BDQIgTmgwV8LfxSyRr97JVUJfPuZyqppiL/1oxdwEDQ2Egeq9A3WODYMSGvEqQavx8zMzMzM7AMHPAQaIlJ0rwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/uis/assets/images/flags/Somalia.png
// module id = 613
// module chunks = 0